import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { ViewChild } from '@angular/core';


@Component({
  selector: 'app-single-marketplace',
  templateUrl: './single-marketplace.component.html',
  styleUrls: ['./single-marketplace.component.css']
})
export class SingleMarketplaceComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  type = this.route.snapshot.params.type;
  marketplaceID = this.route.snapshot.params.marketplaceID;
  currentUserId = this.authService.getTokenData().userID;
  successMessage = false;
  errorMessage = false;
  applicants = [];
  opening;
  subGroups = [];
  selectedSubGroup;
  wellfareAreas = [];
  currentOffer;


  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }


  ngOnInit(): void {
    this.fetchMarketPlaceOpening();

  }

  fetchMarketPlaceOpening() {
    //Epoch time


    this.http.get(environment.MARKET_PLACE_OFFER + '/'+this.marketplaceID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.opening = res.message;
          console.log(this.opening, 'openinni')

          //Check if wellfareas are in ls
          if(!localStorage.getItem('wellfareAreas')){
            this.fetchWellfareAreas();
          }
          else{
            this.wellfareAreas = JSON.parse(localStorage.getItem('wellfareAreas'));
            this.changeWellfareAreaID()
          }
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  markViewedBy(offerID) {
    //Epoch time


    this.http.get(environment.ADD_MARKETPLACE_VIEW + '/'+this.marketplaceID+'/'+offerID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          //edit is_new to false
          for (let i = 0; i < this.opening.offers.length; i++) {
            var offer = this.opening.offers[i];

            if(offer.id == offerID){
              offer.is_new = false;
              break;
            }
            
          }
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }


  fetchWellfareAreas() {
    this.http.get(environment.PARAMS_WELLFAREAREAS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          localStorage.setItem('wellfareAreas', JSON.stringify(res.message));
          this.wellfareAreas = res.message;
          console.log(this.wellfareAreas)
          this.changeWellfareAreaID()
        }
        else {
          this.wellfareAreas = []
        }
      })
  }

  changeWellfareAreaID() {
    for (let i = 0; i < this.wellfareAreas.length; i++) {
      const wf = this.wellfareAreas[i];

      if(wf.id == this.opening.area){
        this.opening.area = wf.name_fi;
        break;  
      }
      
    }
  }


  leaveOffer() {
    this.http.get(environment.SUBGROUPS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message);
          this.subGroups = res.message;
          console.log(this.subGroups)
          document.getElementById('open-offer').click();

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }


  sendOffer(){
    var description = (<HTMLTextAreaElement>document.getElementById('description')).value;
    var hourlyWage = (<HTMLInputElement>document.getElementById('hourlyWage')).value;

    if(hourlyWage == ''){
      alert('Kirjoita tuntipalkkas');
      return;
    }

    //Check if all fields are filled
    if(description == '') {
      alert('Kirjoita tarjoukseen kuvaus');
      return;
    }

    var data = {
      description: description,
      hourlyWage: hourlyWage,
    }

    this.http.put(environment.MARKETPLACE_OFFER + '/'+this.marketplaceID, data, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message);
          this.fetchMarketPlaceOpening();
          this.successMessage = true;
          document.getElementById('close-offer-modal').click();
          //clear fields
          (<HTMLTextAreaElement>document.getElementById('description')).value = '';
          this.selectedSubGroup = undefined;
          setTimeout(() => {
            this.successMessage = false;
          }
          , 5000);
        }
        else {
          setTimeout(() => {
            this.errorMessage = false;
          }
          , 5000);
        }
        
      }
    )
  }

  clearFields(){
    (<HTMLTextAreaElement>document.getElementById('description')).value = '';
    (<HTMLInputElement>document.getElementById('hourlyWage')).value = '';

    
  }

  readOffer(data){
    this.currentOffer = data;
    var is_in_viewed_by = false;
    for (let i = 0; i < data.viewed_by.length; i++) {
      const elm = data.viewed_by[i];
      
      if(elm.employerID.toString() == this.currentUserId.toString()){
        is_in_viewed_by = true;
        break;
      }
      
    }
    if(is_in_viewed_by){
      console.log('already viewed')
    }
    else{
      this.markViewedBy(this.currentOffer.id);
    }
    document.getElementById('open-read-offer').click();
  }

  deleteMarketplace(){

    var elm = (<HTMLInputElement>document.getElementById('deletion-reason')).value;

    if(elm == "" || elm == null){
      alert('Anna poistamisen syy')
      return;
    }
    
    var req = {
      deletion_reason: elm,
    }

    this.http.put(environment.EMPLOYER_DELETE_MARKETPLACE +'/'+ this.marketplaceID, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          document.getElementById('close-confirm-modal').click();
          this.router.navigate(['/'+this.businessID + '/marketplaces/marketplace/' + this.businessID])

        }
        else {
          alert(
            'Poistaminen ei onnistunut. Ole hyvä ja yritä uudelleen'
          )
        }
        
      })

  }
  goBack(){
    window.history.back();
  }

}


